import React from 'react'
import { Link } from 'gatsby'
import { H5 } from '../headings/index'
import { FooterWrapper, FooterGrid, FooterSmallGridWrapper, FooterSmallGrid } from './style'
import Container from '../container/index'
import globals from '../globals'

import LogoMonocromatica from '../../images/logos/ficaazul-monocromatico.svg'
import IconFacebook from '../../images/logos/facebook-f.svg'
import IconInstagram from '../../images/logos/instagram-icon.svg'

const Footer = props => {

  const appWasReleased = process.env.GATSBY_APP_WAS_RELEASED === "true"

  return (
    <FooterWrapper>

      <Container>
        <FooterGrid>
          <div className="about">
            <img src={LogoMonocromatica} alt="FicaAzul" width="155" />
            <p>A plataforma de negociação da CredPago pretende tornar as negociação e a cobrança de valores, um processo simples, intuitivo e permitindo que o devedor pague seu débito com múltiplas formas de pagamento e a credora receba de forma simples; </p>
          </div>
          <div>
            <H5 weight={'bold'}>SUPORTE</H5>
            <ul>
              {appWasReleased && (
                <li><a href={`${globals.externals.app}/solicitar-cadastro`} target="_blank" rel="noreferrer">Cadastrar Empresas</a></li>
              )}         
              <li><Link to ="/faq">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <H5 weight={'bold'}>CONTATO</H5>
            <ul>
              <li>ficaazul@credpago.com</li>
              <li>0800 001 6002</li>
              <li>
                <a href="https://api.whatsapp.com/send?1=pt_BR&phone=5541997487391">
                  WhatsApp: (41) 99748-7391  
                </a>
              </li>
            </ul>
          </div>
        </FooterGrid>
      </Container>
      <FooterSmallGridWrapper>
        <FooterSmallGrid>
          <p>© {new Date().getFullYear()} Todos os direitos reservados</p>
          <nav>
            <ul>
              <li>
                <a href="//www.facebook.com/FicaAzul-100441565033929" target="_blank" rel="noreferrer">
                  <img src={IconFacebook} alt="Facebook" />  
                </a>
              </li>
              <li style={{ transform: 'translateY(1px)' }}>
                <a href="//www.instagram.com/ficaazul/" target="_blank" rel="noreferrer">
                  <img src={IconInstagram} alt="Instagram" />
                </a>
              </li>
            </ul>
          </nav>
        </FooterSmallGrid>
      </FooterSmallGridWrapper>
    </FooterWrapper>
  )
}

export default Footer